import { Injectable, inject } from '@angular/core';
import { AwbData, ShippingType } from '@core/core.types';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '@root/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AwbService {
  private http = inject(HttpClient);

  getShippingType(
    countryCode: string,
    recipientLaboratory: string
  ): Observable<{ shippingType: ShippingType }> {
    return this.http.get<{ shippingType: ShippingType }>(
      `${environment.apiUrl}/shipping/type`,
      {
        params: { countryCode, recipientLaboratory },
      }
    );
  }

  generateDhlWaybill(data: {
    kitId: string;
    recipientLaboratory: string;
    fullName: string;
    companyName: string;
    street: string;
    city: string;
    postCode: string;
    countryCode: string;
    contactNumber: string;
  }): Observable<AwbData> {
    return this.http.post<AwbData>(
      `${environment.apiUrl}/shipping/waybill`,
      data
    );
  }

  getWaybill(id: string) {
    return this.http.get<any>(`${environment.apiUrl}/shipping/waybill/${id}`);
  }
}
